module.exports = __webpack_public_path__ + "static/media/beaverton-small.ad5f2919.webp";